module.exports = __webpack_public_path__ + "img/title6.e6571a47.jpg";